import {IStripeDisabledReason} from "../interfaces/IStripeDisabledReason";

export const StripeDisabledReasons: IStripeDisabledReason[] = [
  {
    code: 'action_required.requested_capabilities',
    reason: 'The account has been disabled because its requested capabilities require action.'
  },
  {
    code: 'listed',
    reason: 'The account has been listed.'
  },
  {
    code: 'other',
    reason: 'The account has been disabled for another reason.'
  },
  {
    code: 'platform_paused',
    reason: 'The account has been paused by the platform.'
  },
  {
    code: 'rejected.fraud',
    reason: 'The account has been rejected for fraud.'
  },
  {
    code: 'rejected.incomplete_verification',
    reason: 'The account has been rejected for incomplete verification.'
  },
  {
    code: 'rejected.listed',
    reason: 'The account has been rejected because it is listed.'
  },
  {
    code: 'rejected.other',
    reason: 'The account has been rejected for another reason.'
  },
  {
    code: 'rejected.platform_fraud',
    reason: 'The account has been rejected by the platform for fraud.'
  },
  {
    code: 'rejected.platform_other',
    reason: 'The account has been rejected by the platform.'
  },
  {
    code: 'rejected.platform_terms_of_service',
    reason: 'The account has been rejected by the platform for violating the Stripe services agreement.'
  },
  {
    code: 'rejected.terms_of_service',
    reason: 'The account has been rejected because it does not meet Stripe\'s terms of service.'
  },
  {
    code: 'requirements.past_due',
    reason: 'The account has been disabled because requirements are past due.'
  },
  {
    code: 'requirements.pending_verification',
    reason: 'The account has been disabled because requirements are pending verification.'
  },
  {
    code: 'under_review',
    reason: 'The account has been disabled because it is under review.'
  }
]










